// app/src/features/share/SendCopyHost.jsx
import React from "react";
import SendCopyModal from "../../components/SendCopyModal.jsx";

/**
 * The send-a-copy modal, rendered inside `AppFrame`'s `modals` slot (desktop-only — the frame
 * renders the slot on its desktop branch alone, last in its fragment) exactly where the inline
 * mount sat: before the preprocess host. Unreachable while `COPY_LINKS_UI_ON_HOLD` holds the copy
 * UI shut (`openSendCopy` is called only by the copy-links panel, which does not render), kept
 * wired so bringing copy back is one constant.
 *
 * `ctx` is the frame context: the copy-link gate's `sendCopyOpen` / `closeSendCopy`, the link
 * list hook's result (`copyLinks`) and the minted-URL stash (`mintedStash`). The host hands `ctx`
 * nowhere.
 */
export default function SendCopyHost({ ctx }) {
  const { sendCopyOpen, closeSendCopy, copyLinks, mintedStash } = ctx;
  return (
    <>
      {/* `sendCopyOpen` already ANDs both gates (useCopyLinksGate), so this needs no second
         guard. `onClose` deliberately does NOT clear `minted`: the mint response is the only
         place the secret ever exists (the server stored a hash), so dismissing it is an
         explicit user action (`onClearMinted`) and a stray click-outside must not destroy a
         live capability the owner has not saved yet. */}
      {sendCopyOpen && (
        <SendCopyModal
          onClose={closeSendCopy}
          minted={copyLinks.minted}
          error={copyLinks.error}
          errorKind={copyLinks.errorKind}
          minting={copyLinks.minting}
          availability={copyLinks.availability}
          // Stashes the mint result so it outlives this modal and a reload. `remember` is total: a
          // storage that refuses keeps the value in memory instead.
          onMint={async (opts) => {
            const body = await copyLinks.mint(opts);
            if (body) mintedStash.remember(body);
            return body;
          }}
          onClearMinted={copyLinks.clearMinted}
        />
      )}
    </>
  );
}
